import { keyframes, styled } from '@clickcease/cc-client-components-lib'

export const TagsAndFiltersContainer = styled('div', {
  display: 'flex',
  flexDirection: 'column',
})

export const FiltersRow = styled('div', {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  height: '30px',
  alignItems: 'center',
  padding: '20px',
})

export const DateAndAdvancedFiltersSection = styled('div', {
  display: 'flex',
  gap: '$8',
})

const scaleAnimation = keyframes({
  '0%': { height: '10px', opacity: 0 },
  '100%': { height: '30px', opacity: 1 },
})

export const TagsContainer = styled('div', {
  display: 'flex',
  marginTop: '$2',
  animation: `${scaleAnimation()} .2s`,
  padding: '6px',
})
